import React from 'react';

import { colorsPalette } from '../../theme';

const VideoIcon = ({
  color = colorsPalette.white,
  secondaryColor = colorsPalette.blue,
  ...rest
}) => {
  return (
    <svg
      width="48"
      height="40"
      viewBox="0 0 48 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16.8642 0.75H25.6939L32.3293 7.25H23.6351L16.8642 0.75ZM34.4728 7.25L27.8374 0.75H36.6893L43.1893 7.25H34.4728ZM47.25 7.25H45.3107L38.8107 0.75H45C46.2426 0.75 47.25 1.75736 47.25 3V7.25ZM45 8.75H47.25V37C47.25 38.2426 46.2426 39.25 45 39.25H3C1.75736 39.25 0.75 38.2426 0.75 37V8.75H12.5H23.3333H34.1667H45ZM10.6088 7.25H0.75V3C0.75 1.75736 1.75736 0.75 3 0.75H3.70257L10.6088 7.25ZM12.7974 7.25L5.89118 0.75H14.6983L21.4691 7.25H12.7974Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M22.125 29.6447L31.875 24.0155C33.0417 23.342 33.0417 21.658 31.875 20.9845L22.125 15.3553C20.9583 14.6817 19.5 15.5237 19.5 16.8708L19.5 28.1292C19.5 29.4763 20.9583 30.3183 22.125 29.6447Z"
        fill={secondaryColor}
        fillOpacity="0.33"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default VideoIcon;
